import _ from "lodash"
import * as Yup from "yup"
import CryptoJS from "crypto-js"
import config from "../../config.json"
import { DateTime } from "luxon"

export const dateformat = "yyyy-MM-dd"
export const dateTimeformat = "yyyy-MM-dd HH:mm:ss"
export const slashformat = "MM/dd/yyyy"
export const timeZone = "America/Chicago"
export const UTC = "UTC"
export const regexp = {
  phone:
    /^((\+1\s?)|(1\s?))?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/,
  alpha: /^[a-zA-Z]*$/,
  alphanumeric: /^[a-zA-Z0-9]*$/,
  number: /^-?\d+$/, // positive or negative
  numeric: /^[0-9]*$/,
  //ssn: /^(?!000|666|9\d\d)\d{3}-(?!00)\d{2}-(?!0000)\d{4}$|^\d{9}$/,
  ssn: /^(?!000|666)[0-9][0-9]{2}\-?(?!00)[0-9]{2}\-?(?!0000)[0-9]{4}$/,
  noitin: /^(?!000|666)[0-8][0-9]{2}\-?(?!00)[0-9]{2}\-?(?!0000)[0-9]{4}$/,
  itin: /(9\d{2})([ \-]?)(5\d|6[0-5]|7\d|8[0-8]|9[0-2,4-9])([ \-]?)(\d{4})/,
  date: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/,
  decimal: /^[0-9]+(\.[0-9]{1,3})?$/, //allows up to 3 decimal spots
  decimal3: /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/, // allows 3 decimal spots can end in decimal e.g. 33.
  integer: /^[1-9][0-9]*$/,
  //zipcode: /^(?!00000)(?<zip>(?<zip5>\d{5})(?:[ -](?=\d))?(?<zip4>\d{4})?)$/,
  zipcode: /^(?!00000)(\d{5})(?:[ -](?=\d))?(\d{4})?$/,
  ccnumber:
    /^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/,
  ipv4: /\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\b/, //-not tested
  aba: /^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2])|(6[1-9])|(7[0-2])|80)([0-9]{7})$/,
}

export const sessionStorageSpace = function () {
  var allStrings = ""
  for (var key in window.sessionStorage) {
    if (window.sessionStorage.hasOwnProperty(key)) {
      allStrings += window.sessionStorage[key]
    }
  }
  return allStrings
    ? 3 + (allStrings.length * 16) / (8 * 1024) + " KB"
    : "Empty (0 KB)"
}

export const showPreloader = () => {
  document.getElementById("preloader").style.display = "block"
  document.getElementById("preloader").style.opacity = "0.75"
  document.getElementById("status").style.display = "block"
}

export const hidePreloader = () => {
  document.getElementById("preloader").style.display = "none"
  document.getElementById("status").style.display = "none"
}

export const decrypt = ciphertext => {
  try {
    var bytes = CryptoJS.AES.decrypt(
      ciphertext,
      process.env.REACT_APP_PRODUCTION === "prod"
        ? config.appPrivateKey
        : config.devPrivateKey
    )
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))[0]
  } catch (error) {
    return {
      error: error.message,
      data: null,
    }
  }
}

export const encrypt = data => {
  try {
    return CryptoJS.AES.encrypt(
      JSON.stringify([data]),
      process.env.REACT_APP_PRODUCTION === "prod"
        ? config.appPrivateKey
        : config.devPrivateKey
    ).toString()
  } catch (error) {
    return {
      error: error.message,
      data: null,
    }
  }
}

export const formatPhoneNumber = phoneNumberString => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "")
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    var intlCode = match[1] ? "+1 " : ""
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("")
  }
  return null
}

export const USDFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
})

export const percentFormat = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const fnDateISOObject = date =>
  DateTime.fromISO(date).setZone(UTC).toObject()

export const dateUTCHumanReadable = date =>
  DateTime.fromISO(date).setZone(UTC).toLocaleString(DateTime.DATE_MED)

export const dateHumanReadable = date =>
  DateTime.fromSQL(date).setZone(timeZone).toLocaleString(DateTime.DATETIME_MED)

export const dateHumanReadableUTC = date =>
  DateTime.fromISO(date, { zone: "utc" })
    .setZone("America/Chicago")
    .toFormat("MM/dd/yyyy")

export const fnGetDateTime = date => {
  return date
    ? DateTime.fromMillis(Date.parse(date)).setZone("America/Chicago")
    : DateTime.now().setZone("America/Chicago")
}

export const fnConvertUTCToString = date => {
  return DateTime.fromMillis(Date.parse(date))
    .setZone("America/Chicago")
    .toFormat("yyyy-MM-dd HH:mm:ss")
}

export const getCurrentTime = () => {
  return DateTime.now()
    .setZone("America/Chicago")
    .toFormat("yyyy-MM-dd HH:mm:ss")
}

export const fnGetDateDiff = (date1, date2, duration) => {
  let dateTime1 = fnGetDateTime(date1)
  let dateTime2 = fnGetDateTime(date2)
  duration ? duration : ["years", "months", "days", "hours"]
  return dateTime1.diff(dateTime2, duration)
}

export const fnDateTimeMinus = (date, duration) => {
  let dataToMinus = date
    ? DateTime.fromSQL(date).setZone(timeZone)
    : DateTime.now().setZone(timeZone)
  return dataToMinus.minus(duration) //{days: 1, months: 3, years: 2}
}

export const fnDateTimeFromSql = date =>
  DateTime.fromSQL(date).setZone(timeZone)

export const fnDateTimePlus = (date, duration) => {
  let dataToAdd = date
    ? DateTime.fromSQL(date).setZone(timeZone)
    : DateTime.now().setZone(timeZone)
  return dataToAdd.plus(duration) //{days: 1, months: 3, years: 2}
}

export const fnConvertUTCToDateTime = date => {
  return DateTime.fromMillis(Date.parse(date)).setZone(timeZone)
}

export const fnDateTimeFromISO = date => DateTime.fromISO(date, { zone: "utc" })

//.setZone("America/Chicago").toFormat("yyyy-MM-dd HH:mm:ss");

export const findElementPositionById = id => {
  let elem = document.getElementById(id)

  if (_.size(elem) < 1) return false

  let curleft = 0
  let curtop = 0

  if (elem.offsetParent) {
    do {
      curleft += elem.offsetLeft
      curtop += elem.offsetTop
    } while ((elem = elem.offsetParent))
  }

  return [curleft, curtop]
}

export const getFileIcon = ext =>
  _.isUndefined(fileIcons[ext]) ? fileIcons.document : fileIcons[ext]

export const fileIcons = {
  document: "mdi mdi-file-document font-size-16 align-middle text-primary me-2",
  txt: "mdi mdi-file-document font-size-16 align-middle text-primary me-2",
  zip: "mdi mdi-folder-zip font-size-16 align-middle text-warning me-2",
  pdf: "fas fa-file-pdf font-size-16 align-middle text-danger me-2",
  powerpoint:
    "mdi mdi-file-powerpoint-box font-size-16 align-middle text-primary me-2",
  docx: "mdi mdi-file-word font-size-16 align-middle text-success me-2",
  m4a: "mdi mdi-play-circle font-size-16 align-middle text-danger me-2",
  csv: "fas fa-file-csv font-size-16 align-middle text-success me-2",
  xlsx: "bx bxs-spreadsheet font-size-16 align-middle text-success me-2",
  png: "fas fa-file-image font-size-16 align-middle text-primary me-2",
  jpg: "fas fa-file-image font-size-16 align-middle text-primary me-2",
  jpeg: "fas fa-file-image font-size-16 align-middle text-primary me-2",
  msg: "mdi mdi-email font-size-16 align-middle text-dark me-2",
  eml: "mdi mdi-email font-size-16 align-middle text-dark me-2",
}
